/**
 * In the MyRave app, alerts are asked for BY THEMSELVES (the user, 2026-10-07:
 * "the app should ask to allow notifications automatically") — as soon as
 * somebody signed in and let in is on screen, once per launch. The phone shows
 * its own "Allow notifications?" the first time; after that the answer is
 * the phone's, and asking again only re-registers the address (the server can
 * lose it — a staging copy replaces the table). Turning alerts off on the
 * account page stops it (`nativePushTurnedOff`).
 *
 * Renders nothing. Outside the app (a browser) it does nothing at all: Web
 * Push stays a choice made on the account page.
 */
import { useEffect, useRef } from 'react';
import { inNativeApp } from '@/lib/nativeBridge';
import { nativePushTurnedOff, registerNativePush } from '@/lib/nativePush';
import { useAuth } from './AuthProvider';

export function NativePushAuto() {
  const { user, offline } = useAuth();
  const askedFor = useRef<string | null>(null);
  useEffect(() => {
    if (!user || offline || !(user.approved || user.role === 'SUPER_ADMIN')) return;
    if (!inNativeApp() || nativePushTurnedOff()) return;
    if (askedFor.current === user.id) return;
    askedFor.current = user.id;
    void registerNativePush();
  }, [user, offline]);
  return null;
}
